import { Capacitor } from '@capacitor/core'
import { StatusBar, Style } from '@capacitor/status-bar'

/**
 * Configure status bar so the app doesn't paint behind it.
 *
 * Android: opt out of the WebView overlay so the system bar gets its own
 * solid background — avoids the "clock overlaps header" problem with
 * viewport-fit=cover.
 *
 * iOS: still overlay-style by default; CSS safe-area-inset-top in
 * AppHeader handles the gap.
 */
export function setupStatusBar(): void {
  if (!Capacitor.isNativePlatform()) return

  // Marker class CSS uses to drop the glass effect on the sticky header,
  // which leaks scrolled content under the bar on mobile.
  document.documentElement.classList.add('is-native-mobile')

  StatusBar.setStyle({ style: Style.Dark }).catch(() => {})

  if (Capacitor.getPlatform() === 'android') {
    StatusBar.setOverlaysWebView({ overlay: false }).catch(() => {})
    StatusBar.setBackgroundColor({ color: '#15171a' }).catch(() => {})
  }
}
